import React from 'react';
export function StorySection() {
  return <section id="storia" className="w-full bg-gradient-to-b from-green-50 to-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center" data-id="element-209">
          La storia di Elena, 64 anni (e di come ha ritrovato se stessa)
        </h2>
        <div className="bg-white p-8 sm:p-12 rounded-lg shadow-lg border border-gray-200" data-id="element-210">
          <div className="space-y-6 text-lg sm:text-xl text-gray-700" data-id="element-211">
            <p className="text-2xl font-semibold text-gray-900 italic" data-id="element-212">
              "Per mesi ho evitato conversazioni lunghe: temevo di perdere il
              filo. Dimenticavo i nomi dei vicini, il compleanno di mia nipote.
              Mi sentivo… più piccola."
            </p>
            <p data-id="element-213">Dopo 3 settimane con VitaCognitiva, Elena annota:</p>
            <p className="text-2xl font-semibold text-green-700 italic" data-id="element-214">
              "Dormo meglio, ricordo le liste senza rileggerle, mi sento più
              presente con mia sorella. La cosa più bella? Non ho più paura di
              dimenticare mentre parlo."
            </p>
            <p className="text-xl font-bold text-gray-900 text-center pt-6" data-id="element-215">
              Non è magia. È un metodo quotidiano, umano, sostenibile.
            </p>
          </div>
        </div>
      </div>
    </section>;
}